"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmTemplateSetup = exports.CrmIntegrationSetup = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var CallToAction_1 = __importDefault(require("Project/Actions/CallToActions/CallToAction"));
var CrmIntegrationSetup = function (_a) {
    var getIntegrationSettingsUrl = _a.getIntegrationSettingsUrl, getHelpArticleUrl = _a.getHelpArticleUrl;
    return (react_1.default.createElement(CallToAction_1.default, { text: "Connect a CRM to add personalisation tokens.", image: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "cta__icon" },
                react_1.default.createElement(icons_1.Hubspot, { size: icons_1.IconSize.Large })),
            react_1.default.createElement("div", { className: "cta__icon cta__icon--layered" },
                react_1.default.createElement(icons_1.Salesforce, { size: icons_1.IconSize.Large }))), primaryButtonAction: getIntegrationSettingsUrl(), primaryButtonText: "Go to CRM integrations", learnMoreHref: getHelpArticleUrl() }));
};
exports.CrmIntegrationSetup = CrmIntegrationSetup;
var CrmTemplateSetup = function (_a) {
    var onAddToCrm = _a.onAddToCrm, getHelpArticleUrl = _a.getHelpArticleUrl;
    return (react_1.default.createElement(CallToAction_1.default, { text: "Connect to your CRM and pull personalised details into your pages.", image: react_1.default.createElement(kaleidoscope_1.SVG, { src: "/Assets/icons/token-typing.svg" }), primaryButtonAction: onAddToCrm, primaryButtonText: "Add to CRM", learnMoreHref: getHelpArticleUrl() }));
};
exports.CrmTemplateSetup = CrmTemplateSetup;
